import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.object.keys.js";
import React from "react";

/* eslint-disable react/no-unused-prop-types */
import PropTypes from 'prop-types';
export var ALIGN = {
  center: 'center',
  left: 'left',
  right: 'right'
};
export var propTypes = {
  /**
   * The content used by that analytics module and the flag to determine if analytics is sent
   */
  analytics: PropTypes.shape({
    enabled: PropTypes.bool,
    payload: PropTypes.shape({
      elementName: PropTypes.string,
      sectionName: PropTypes.string,
      sectionPosition: PropTypes.number
    })
  }),

  /**
    Text to be consumed by assistive technology (like screen readers)
    to better guide users on the context of what the table is showing.
    Eg. “Table of Today’s Mortgage Rates”.
  */
  'aria-label': PropTypes.string,

  /**
    Pass to `aria-labelledby` the unique ID of an existing label for
    the table. This can be useful if you have a visually existing title
    element for the table that you would like to associate which prevents
    assistive technologies from reading the title twice.
  */
  'aria-labelledby': PropTypes.string,

  /** Classes to apply to the <table> component. */
  className: PropTypes.string,

  /** Columns configuration - based on https://www.npmjs.com/package/rc-table. */
  columns: PropTypes.arrayOf(PropTypes.shape({
    /**  Unique ID to be referenced as a prop in row data. */
    id: PropTypes.string.isRequired,

    /** Heading to appear in the column's <th>. */
    heading: PropTypes.node,

    /** Explicit width for the column. Only supported for Table. */
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

    /** Explicit minimum width for the column. Only supported for in Table Simple */
    minWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

    /** Left-affix the column for responsive behavior. This is supported for multiple columns, however they must be adjacent. */
    fixed: PropTypes.bool,

    /** Classes to apply to all cells in the column. */
    className: PropTypes.string,

    /** colSpan value for this cell in the header row */
    colSpan: PropTypes.number,

    /** how to align all cells in this column */
    align: PropTypes.oneOf(Object.keys(ALIGN))
  })).isRequired,

  /** Rows configuration - based on https://www.npmjs.com/package/rc-table. */
  data: PropTypes.arrayOf(PropTypes.shape({
    /** Unique ID to use for a row's React key. */
    key: PropTypes.string,

    /** Classes to apply to all cells in the row. */
    className: PropTypes.string,

    /**
     * Object that defines colSpan values for column ids
     * Eg: { myColumnId: 3, myOtherColumnId: 2 }
     */
    colSpans: PropTypes.objectOf(PropTypes.number),

    /** how to align all cells in this row */
    align: PropTypes.oneOf(Object.keys(ALIGN))
  })).isRequired,

  /** Renders table header row */
  hasTableHeader: PropTypes.bool,

  /** Hover highlighting on rows */
  rowHover: PropTypes.bool,

  /** Alternate background color for every other row. */
  striped: PropTypes.bool
};
export var defaultProps = {
  'aria-label': null,
  'aria-labelledby': null,
  className: null,
  hasTableHeader: true,
  rowHover: false,
  striped: true
}; // What's going on here? Well, the style guide uses react-docgen to extract
// prop type information from components. However, react-docgen can't resolve
// prop types across file boundaries. So, to produce useful output, we make a
// fake component here that react-docgen can parse. This component is useless
// and should never actually be used by anyone.

export var Table = function Table() {
  return /*#__PURE__*/React.createElement("div", null, "DO NOT USE ME.");
};
Table.propTypes = propTypes;
Table.defaultProps = defaultProps;